import { Component, ChangeDetectorRef, OnDestroy } from '@angular/core';
import {MediaMatcher} from '@angular/cdk/layout';
import {environment} from '../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {LANG} from './configs';
import {Store} from '@ngrx/store';
import {AppState} from './store/AppState';
import {Observable} from 'rxjs';
import {getShowHeader} from './store/showHeader/reducer';
import { MatDrawer } from '@angular/material/sidenav';
import { getService } from './store/service/selectors';
import { Service } from './store/service/Service';

@Component({
  selector: 'girko-app',
  template: `
    <girko-login *ngIf="!isProduction"></girko-login>
    <girko-header-connected *ngIf="showHeader$ | async" (hamburgerClick)="sidenav.toggle()"></girko-header-connected>
    <mat-sidenav-container class="user-cabinet-container" (backdropClick)="sidenav.close()">
      <mat-sidenav
        #sidenav
        [mode]="mobileQuery.matches ? 'over' : 'side'"
        [opened]="!mobileQuery.matches && (service$ | async)?.active"
        (keydown.escape)="sidenav.close()"
      >
        <mat-nav-list>
          <a
            mat-list-item
            routerLinkActive="active"
            *ngFor="let route of routes"
            (click)="onMenuItemClick(sidenav)"
            [routerLink]="[route.path]"
            >
            {{route.title | async}}
          </a>
        </mat-nav-list>
      </mat-sidenav>
      <mat-sidenav-content>
         <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  `,
})
export class GirkoComponent implements OnDestroy {
  isProduction = environment.production;
  service$: Observable<Service> = this.store.select(getService);
  showHeader$: Observable<boolean> = this.store.select(getShowHeader);
  routes = [
    {
      path: 'edit',
      title: this.translate.stream('Редагувати профіль'),
    },
    {
      path: 'auction',
      title: this.translate.stream('Аукціон TOP'),
    },
    {
      path: 'analytics',
      title: this.translate.stream('Статистика'),
    },
  ];


  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public translate: TranslateService,
    private store: Store<AppState>) {
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    translate.use(LANG);

    this.service$.subscribe(service => {
      if (service && !service.active) {
        this.routes = [this.routes[0]];
      }
    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  onMenuItemClick(sidenav: MatDrawer) {
    if (this.mobileQuery.matches) {
      sidenav.close();
    }
  }
}
